import { buildCollection, buildProperty } from "@firecms/core";
import { platformEnumValues } from "./shared/enums";
import { MissingOrNumberPreview } from "./shared/missing_number";

export type Device = {
    deviceId?: string;
    platform?: keyof typeof platformEnumValues;
    freeTrialLeft?: number;
    createdAt?: Date;
};

/**
 * devices/{deviceId} — cihaz bazlı ücretsiz deneme. Salt okunur.
 * platform yalnızca ilk kayıtta Flutter tarafından yazılır.
 */
export const devicesCollection = buildCollection<Device>({
    id: "devices",
    name: "Cihazlar",
    singularName: "Cihaz",
    path: "devices",
    group: "Kullanıcılar",
    icon: "smartphone",
    description: "Cihaz başına kalan ücretsiz deneme (salt okunur)",
    initialSort: ["createdAt", "desc"],
    permissions: {
        read: true,
        create: false,
        edit: false,
        delete: false,
    },
    properties: {
        deviceId: buildProperty({
            name: "Cihaz ID",
            dataType: "string",
            readOnly: true,
        }),
        platform: buildProperty({
            name: "Platform",
            dataType: "string",
            enumValues: platformEnumValues,
            readOnly: true,
        }),
        freeTrialLeft: buildProperty({
            name: "Kalan deneme",
            dataType: "number",
            readOnly: true,
            Preview: MissingOrNumberPreview,
        }),
        createdAt: buildProperty({
            name: "Oluşturulma",
            dataType: "date",
            mode: "date_time",
            readOnly: true,
        }),
    },
});
